import axios from 'axios'
import {AzSearchUrlBuilder} from '@azinformatica/loki'

class RelatorioApiClient {

    async baixarRelatorioInventarioAnalitico(filtros) {
        let url = AzSearchUrlBuilder.build(
            'api/relatorios/inventario/analitico',
            filtros,
            {}
        )
        url += `&origem=${filtros.origem}`
        return axios.get(url,
            {
                responseType: 'arraybuffer'
            })
    }

    async baixarRelatorioInventarioSintetico(filtros) {
        let url = AzSearchUrlBuilder.build(
            'api/relatorios/inventario/sintetico',
            filtros
        )
        url += `&origem=${filtros.origem}`
        return axios.get(url,
            {
                responseType: 'arraybuffer'
            })
    }

    async baixarListagemPatrimonioXLS(filtros,paginacao){
        paginacao.descending = !paginacao.sortDesc[0]
        const url = AzSearchUrlBuilder.build('api/relatorios/listagemPatrimonio/xls',filtros,paginacao)
        return axios.get(url,{responseType:'arraybuffer'})
    }

    async baixarRelatorioMemorandoPDF(patrimonio) {
        const url = `api/relatorios/memorando/pdf/${patrimonio}`
        return axios.get(url, {responseType: 'arraybuffer'})
    }

    async baixarRelatorioMemorandoMovimentacaoPDF(movimentacao) {
        const url = `api/relatorios/memorando/movimentacao/pdf/${movimentacao}`
        return axios.get(url, {responseType: 'arraybuffer'})
    }

    async baixarRelatorioMemorandoReavaliacaoPDF(reavaliacao) {
        const url = `api/relatorios/memorando/reavaliacao/pdf/${reavaliacao}`
        return axios.get(url, {responseType: 'arraybuffer'})
    }

    async baixarRelatorioMemorandoAjustePDF(ajusteId) {
        const url = `api/relatorios/memorando/ajuste/${ajusteId}`
        return axios.get(url)
    }
}

export default new RelatorioApiClient()
